module.exports = __webpack_public_path__ + "static/img/cop_sch_logo25.ded9f58d.png";